(function () {
  function initReturnChecker(root) {
    var windowDays = parseInt(root.getAttribute('data-window-days'), 10) || 14;
    var pieceGroup = root.querySelector('[data-rc-group="piece"]');
    var conditionGroup = root.querySelector('[data-rc-group="condition"]');
    var slider = root.querySelector('[data-rc-days-slider]');
    var daysValueEl = root.querySelector('[data-rc-days-value]');
    var result = root.querySelector('[data-rc-result]');
    var resultStatus = root.querySelector('[data-rc-result-status]');
    var resultText = root.querySelector('[data-rc-result-text]');

    if (!pieceGroup || !conditionGroup || !slider || !result) return;

    function getActiveValue(group) {
      var active = group.querySelector('.rc-pill.is-active');
      return active ? active.getAttribute('data-rc-value') : null;
    }

    function setActive(group, button) {
      var pills = group.querySelectorAll('.rc-pill');
      for (var i = 0; i < pills.length; i++) {
        pills[i].classList.remove('is-active');
      }
      button.classList.add('is-active');
    }

    function evaluate() {
      var piece = getActiveValue(pieceGroup);
      var condition = getActiveValue(conditionGroup);
      var days = parseInt(slider.value, 10);

      daysValueEl.textContent = days + (days === 1 ? ' day' : ' days');

      var reasons = [];
      if (piece === 'custom') {
        reasons.push('custom and bespoke pieces are made to order and are not eligible for return');
      }
      if (condition === 'worn') {
        reasons.push('the item must be unworn and in its original condition to qualify');
      }
      if (days > windowDays) {
        reasons.push('the ' + windowDays + '-day return window has passed');
      }

      if (reasons.length === 0) {
        result.classList.remove('is-ineligible');
        resultStatus.textContent = 'Eligible';
        resultText.textContent = 'You\'re within the ' + windowDays + '-day window. Email us with your order number and we\'ll send return instructions.';
      } else {
        result.classList.add('is-ineligible');
        resultStatus.textContent = 'Likely not eligible';
        resultText.textContent = 'Based on what you\'ve selected, ' + reasons.join(' and ') + '. If you think there\'s an exception, contact us and we\'ll take a look.';
      }
    }

    pieceGroup.addEventListener('click', function (e) {
      var btn = e.target.closest('.rc-pill');
      if (!btn) return;
      setActive(pieceGroup, btn);
      evaluate();
    });

    conditionGroup.addEventListener('click', function (e) {
      var btn = e.target.closest('.rc-pill');
      if (!btn) return;
      setActive(conditionGroup, btn);
      evaluate();
    });

    slider.addEventListener('input', evaluate);

    evaluate();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-return-checker]');
    for (var i = 0; i < roots.length; i++) {
      initReturnChecker(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
